import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Link } from 'react-router-dom'
import styles from './index.module.css'

const NoticeDetail = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page padding pt_20">
			<div className={styles["detail-title"]}>
				<p>시스템 점검으로 인한 서비스 일시 제한 안내</p>
				<span>2021.12.05</span>
			</div>
			<hr className="my_30" />
			<div className={styles["detail-content"]}>
				<p>
					안정적인 서비스 제공을 위해 시스템 점검을 실시할 예정입니다.<br />
					일부 서비스는 이용이 불가능하니 양해 부탁드립니다.
				</p>
				<p>
					◼︎ 일시<br />
					2021년 08월 16일 (월)
				</p>
				<p>
					시스템 점검기간에 대해 문의사항이 있으시면<br />
					061-123-456로 전화주시거나<br />
					<Link to="">http://www.moneey.co.kr/</Link>으로 연락주세요.
				</p>
			</div>
		</div>
	)
}

export default NoticeDetail